export default __webpack_public_path__ + "static/media/us-in.dcc0684c.svg";